// Copied verbatim from eval/dashboard/internal_web/src/components/ui/EmptyState.tsx (ATM-57). Keep in step until ATM-60 shares it.
import { Inbox } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "../../lib/cn";

type Props = {
  title: string;
  /** Say what the scope excluded, so the fix is obvious. */
  message?: ReactNode;
  /** A way out — usually "clear filters" or "widen the scope". */
  action?: ReactNode;
  className?: string;
};

/**
 * No rows for this scope. Distinct from an unknowable rate: this is "the filter
 * matched nothing", which is a scope problem the reviewer can undo.
 */
export default function EmptyState({ title, message, action, className }: Props) {
  return (
    <div className={cn("grid place-items-center gap-2 px-4 py-10 text-center", className)}>
      <Inbox size={22} className="text-ink-muted" aria-hidden />
      <p className="text-ink">{title}</p>
      {message !== undefined ? <p className="max-w-md text-sm text-ink-2">{message}</p> : null}
      {action !== undefined ? <div className="mt-1">{action}</div> : null}
    </div>
  );
}
